/** @format */
import { css } from 'styled-components';

import { StyledToggleFavouriteProps } from './types';

const baseStyles = () => css`
    .toggle-favourite-icon {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
    }
`;

export const styles = (props: StyledToggleFavouriteProps) => css`
    ${baseStyles()}
`;
